<template>
  <v-dialog
    v-model="model"
    :attach="attach"
    :width="width"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :scrollable="scrollable"
  >
    <v-card class="base-dialog" :class="{ 'rounded-0': fullscreen }">
      <v-card-title class="base-dialog__title primary--text">
        {{ title }}
        <v-spacer />
        <slot name="title-extra" />
        <v-btn icon small @click="model = false">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle v-if="subtitle" class="base-dialog__subtitle">
        {{ subtitle }}
      </v-card-subtitle>

      <v-divider />

      <v-card-text class="base-dialog__content">
        <slot />
      </v-card-text>

      <template v-if="$slots.actions">
        <v-divider />

        <v-card-actions class="base-dialog__actions">
          <slot name="actions" />
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },

    width: {
      type: [String, Number],
      default: 500,
    },

    fullscreen: {
      type: Boolean,
      default: false,
    },

    persistent: {
      type: Boolean,
      default: false,
    },

    attach: {
      type: [Boolean, String],
      default: undefined,
    },

    scrollable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    model: {
      handler(isOpen) {
        if (isOpen) {
          document.documentElement.classList.add('travar-scroll-global')
        } else {
          document.documentElement.classList.remove('travar-scroll-global')
        }
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    document.documentElement.classList.remove('travar-scroll-global')
  },
}
</script>

<style scoped>
.base-dialog {
  border-radius: 14px !important;
  overflow: hidden;
}

.base-dialog.rounded-0 {
  border-radius: 0 !important;
}

.base-dialog__title {
  font-size: 16px;
  font-weight: 600;
  padding: 16px 20px;
  color: var(--v-primary-base) !important;
}

.base-dialog__subtitle {
  padding: 0 20px 16px;
}

.base-dialog__content {
  padding: 20px !important;
  overflow-x: hidden;
}

.base-dialog__actions {
  padding: 16px 24px 24px !important;
  justify-content: flex-end;
}
</style>

<style>
html.travar-scroll-global,
html.travar-scroll-global body {
  overflow: hidden !important;
}
</style>
